export default "/_next/static/73aeca942d79aaf7d3541e79faf39852.gif";